import { useState, useCallback } from "react";

export const useLoadingState = (initialState = false) => {
  const [loading, setLoading] = useState(initialState);

  const withLoading = useCallback(async (asyncFunction) => {
    setLoading(true);
    try {
      const result = await asyncFunction();
      return result;
    } finally {
      setLoading(false);
    }
  }, []);

  const setLoadingState = useCallback((state) => {
    setLoading(state);
  }, []);

  return {
    loading,
    setLoading: setLoadingState,
    withLoading,
  };
};

export default useLoadingState;
